import React, { createContext, useState, useEffect, useContext } from 'react';
// import * as auth from '../services/mockAuth';
import Swal from 'sweetalert2';
import api from '../services/api';

const AuthContext = createContext({});

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [acessos, setAcessos] = useState([]);
  const [socket, setSocket] = useState(null);
  const [msgTodos, setMsgTodos] = useState([]);
  const [msgMinhas, setMsgMinhas] = useState([]);

  // const [msgMinhasCounter, setMsgMinhasCounter] = useState(0);

  useEffect(() => {
    async function loadStorageData() {
      const {
        usuario: storagedUser,
        token: storagedToken,
        acessos: storagedAcessos,
      } = localStorage;

      api.interceptors.response.use(
        (res) => res,
        (error) => {
          if (error?.response?.status === 401 || error?.status === 401) {
            setUser(null);
            localStorage.clear();
            // window.location.reload();
            Swal.close();
            return Promise.reject(error);
          }
          return Promise.reject(error);
        }
      );

      if (storagedUser && storagedToken) {
        setUser(JSON.parse(storagedUser));
        api.defaults.headers.Authorization = `Bearer ${storagedToken}`;
      }

      if (storagedAcessos) {
        setAcessos(JSON.parse(storagedAcessos));
      }

      setLoading(false);
    }

    loadStorageData();
  }, []);

  async function signIn({ senha, email }) {
    try {
      const response = await api.post('/sessions', {
        email,
        senha,
      });
      if (response?.data) {
        api.defaults.headers.Authorization = `Bearer ${response?.data?.token}`;

        localStorage.setItem('acessos', JSON.stringify(response?.data?.telas));
        localStorage.setItem(
          'usuario',
          JSON.stringify(response?.data?.usuario)
        );
        localStorage.setItem('token', response?.data?.token);
        setUser(response?.data?.usuario);
        setAcessos(response?.data?.telas);
        window.scrollTo(0, 0);
      }
    } catch (error) {
      throw error?.response?.data?.error;
    }
  }

  async function signOut() {
    localStorage.clear();
    setUser(null);
  }

  function changeUser({ nome }) {
    setUser((old) => {
      localStorage.setItem('usuario', JSON.stringify({ ...old, nome }));

      return { ...old, nome };
    });
  }

  return (
    <AuthContext.Provider
      value={{
        signed: !!user,
        user,
        loading,
        signIn,
        signOut,
        acessos,
        socket,
        setSocket,
        msgTodos,
        setMsgTodos,
        msgMinhas,
        setMsgMinhas,
        changeUser,
        // setMsgMinhasCounter,
        // msgMinhasCounter,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider.');
  }

  return context;
}

export { AuthProvider, useAuth };
